export default class Resources {

    constructor() {
        this.addEvents();
    }

    addEvents() {
        $( document ).ready(function() {
            checkFilter();

            $('.resource-search .icon-search').on('click', function (e){
                e.preventDefault();
                let parent = $(this).parents('.resource-search');
                if(parent.hasClass('open')){
                    parent.removeClass('open')
                }else{
                    parent.addClass('open');
                    parent.find('input').focus();
                }
            })

            $('.resource-type__label').on('click', function (e){
                let options = $('.resource-type__options');
                options.hasClass('open') ? options.removeClass('open') : options.addClass('open');
            })


            $('.resource-type__options').on('click', '.option', function (e){
                $('.resource-type__options').removeClass('open');
                $(this).hasClass('active') ? $(this).removeClass('active') : $(this).addClass('active');
                generateLink();
            })

            if($('.resource-type__options .option').length > 0) {
                $('.resource-type__options .option').sort(function (a, b) {
                    if ($(a).data("name") < $(b).data("name")) {
                        return -1;
                    } else {
                        return 1;
                    }
                }).appendTo('.resource-type__options');
            }

            $('.resource-filter__list').on('click', 'div', function (e){
                e.preventDefault();
                let id = $(this).attr('data-id');
                $(this).remove();
                $('.resource-type__options .option[data-id="'+id+'"]').removeClass('active');
                if($(this).hasClass('match')){
                    $('.resource-search input').val('');
                }
                generateLink();
            })

            $('.resource-filter__clear').on('click', function (e){
                e.preventDefault();
                $('.resource-type__options .option').removeClass('active');
                window.location = '/resources';
            })

            $('.resource-search input').on('keyup', function (e) {
                if (e.key === 'Enter' || e.keyCode === 13) {
                    e.preventDefault();
                    generateLink();
                }
            })

            function checkFilter(){
                $('.resource-filter__list div').remove();

                $('.resource-type__options .option.active').each(function (ii,ee){
                    let name = $(this).find('span').text();
                    let id = $(this).attr('data-id');
                    let slug = $(this).attr('data-slug');
                    $('<div data-id="'+id+'" data-slug="'+slug+'">'+name+'</div>').appendTo('.resource-filter__list');
                })

                if($('.resource-search input').val()){
                    $('<div class="match">Matches <span>“'+$('.resource-search input').val()+'”</span></div>').appendTo('.resource-filter__list');
                }

                if($('.resource-filter__list div').length == 0){
                    $('.resource-filter__active').removeClass('active');
                }else{
                    $('.resource-filter__active').addClass('active');
                }


            }

            function generateLink(){
                let type = [];
                let search = '';
                $('.resource-type__options .option.active').each(function (ii,ee){
                    let slug = $(this).attr('data-slug');
                    type.push(slug);
                })

                if($('.resource-search input').val()){
                    search = $('.resource-search input').val();
                }

                if(type && type.length > 0){
                    if(search.length > 0){
                        window.location = '/resources?type='+type.join(',')+'&search='+search;
                    }else{
                        window.location = '/resources?type='+type.join(',');
                    }
                }else if(search.length > 0){
                    window.location = '/resources?search='+search;
                }else{
                    window.location = '/resources';
                }
            }

        })
    }

}